<template>
    <spinner-until :condition="participantLoaded">
        <participant-menu>
            <div class="my-questionnaires">
                <b-row>
                    <b-col cols="12" lg="6">

                        <!-- (invited) questionnaires -->
                        <b-card no-body>
                            <b-card-header v-if="!showParticipantMenuAsAccordion">
                                <my-questionnaire-list-badge class="float-right">
                                </my-questionnaire-list-badge>

                                <h5>
                                    <span class="icon-wrapper icon-wrapper-left">
                                        <shs-icon name="question-mark"></shs-icon>
                                    </span>
                                    {{ $i18n.gt('HEADING_MY_QUESTIONNAIRES') }}
                                </h5>
                            </b-card-header>

                            <b-card-body class="light-bg pt-0">
                                <my-questionnaire-list>
                                </my-questionnaire-list>
                            </b-card-body>
                        </b-card>

                    </b-col>
                    <b-col cols="12" lg="6">
                        <b-card no-body>
                            <b-card-header>
                                <h5>{{ $i18n.gt('HEADING_PROGRESS_NOTES') }}</h5>
                            </b-card-header>
                            <b-card-body>
                                <survey-note-list :for-patient="true">
                                </survey-note-list>
                            </b-card-body>
                        </b-card>
                    </b-col>
                </b-row>
            </div>
        </participant-menu>
    </spinner-until>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import Vue from 'vue'
import PatientPageMixin from '@/providers/PatientPageMixin'

/**
 * Page for a Participant to view their completed Surveys or start/continue a Survey
 */
export default Vue.extend({
    name: 'MyQuestionnaires',
    mixins: [PatientPageMixin]
})
</script>
